export default __webpack_public_path__ + "static/Entenda0035-2a9fdaf08b75b29c4629c1e3ecd36cdd.jpg";